export const t = 600
export const tl = 1024
export const d = 1280
export const dl = 1980
